module.exports = __webpack_public_path__ + "img/shield-zagreus.0467c48b.jpg";